import React, { useState, useEffect } from 'react';
import { Card } from '@mui/material';
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import { FaUserSecret } from 'react-icons/fa'; // Ícone de fraudador
import colors from 'assets/theme/base/colors';
import linearGradient from 'assets/theme/functions/linearGradient';
import { api } from 'services/api'; // Importar o serviço de API
import { logger } from 'services/logger';

const SatisfactionRate = ({ totalFraudsters }) => {
	const { info, gradients } = colors;
	const { cardContent } = gradients;
	

	return (
		<Card sx={{ height: '340px', justifyContent: 'center' }}>
			<VuiBox display='flex' flexDirection='column'>
				<VuiTypography variant='lg' color='white' fontWeight='bold' mb='4px'>
					Fraudadores mapeados
				</VuiTypography>
				<VuiTypography variant='button' color='text' fontWeight='regular' mb='20px'>
					Em toda a rede
				</VuiTypography>
				<VuiBox sx={{ alignSelf: 'center', justifySelf: 'center', zIndex: '1' }}>
					{/* Ícone do Fraudador */}
					<VuiBox
						sx={{
							background: info.main,
							width: '120px',
							height: '120px',
							borderRadius: '50%',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<FaUserSecret size='60px' color='#fff' />
					</VuiBox>
				</VuiBox>
				<VuiBox
					sx={({ breakpoints }) => ({
						width: '90%',
						padding: '18px 22px',
						display: 'flex',
						justifyContent: 'space-between',
						flexDirection: 'row',
						height: '82px',
						mx: 'auto',
						borderRadius: '20px',
						background: linearGradient(cardContent.main, cardContent.state, cardContent.deg),
						transform: 'translateY(-50%)', // Move o card para cima para sobrepor o ícone
						zIndex: '1000'
					})}>
					<VuiBox /> 
					<VuiBox
						flexDirection='column'
						display='flex'
						justifyContent='center'
						alignItems='center'
						sx={{ minWidth: '80px' }}>
						<VuiTypography color='white' variant='h2' fontWeight='bold'>
							{totalFraudsters}
						</VuiTypography>
						<VuiTypography color='text' variant='caption' fontWeight='regular' textAlign="center">
							Baseado no Machine Learning Database
						</VuiTypography>
					</VuiBox>
					<VuiBox />
				</VuiBox>
			</VuiBox>
		</Card>
	);
};

export default SatisfactionRate;
